var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-block w-100" },
    [
      _c("label", { staticClass: "font-size-12" }, [
        _vm._v(_vm._s(_vm.label ? _vm.label : "Font Family")),
      ]),
      _c("v-select", {
        attrs: { options: _vm.fontFamily, clearable: false, searchable: false },
        scopedSlots: _vm._u([
          {
            key: "option",
            fn: function (option) {
              return [
                _c("span", { style: { fontFamily: option.val } }, [
                  _vm._v(_vm._s(option.label)),
                ]),
              ]
            },
          },
        ]),
        model: {
          value: _vm.selected,
          callback: function ($$v) {
            _vm.selected = $$v
          },
          expression: "selected",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }